import { render } from "./ChronicFatigueIndexCard.vue?vue&type=template&id=ed67eaba&scoped=true"
import script from "./ChronicFatigueIndexCard.vue?vue&type=script&lang=js"
export * from "./ChronicFatigueIndexCard.vue?vue&type=script&lang=js"

import "./ChronicFatigueIndexCard.vue?vue&type=style&index=0&id=ed67eaba&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed67eaba"]])

export default __exports__